export default __webpack_public_path__ + "static/media/hero-caro-mbl-new-1.4e254cb3.png";